import { useState, useCallback } from 'react'

import { toast } from 'react-toastify'

import IConversation from '../interfaces/conversation'

import isHttpError from '../helpers/helper-http-error'

const useInterlocutors = (remote: any, conversations: IConversation[]) => {
  const [interlocutors, setInterlocutors] = useState<any[]>([])

  const fetchInterlocutors = useCallback(async () => {
    if (conversations.length) {
      try {
        const interlocutorsPromises = await Promise.all(
          conversations.map(async (conversation) => {
            const interlocutor = await remote().loadById(
              Number(conversation.id),
            )

            return {
              ...interlocutor,
              messages: conversation.messages,
              id: conversation.id,
            }
          }),
        )

        setInterlocutors(interlocutorsPromises)
      } catch (error) {
        const httpError = isHttpError(error)

        if (httpError) {
          toast.error(httpError.message)
        } else {
          throw error
        }
      }
    }
  }, [remote, conversations])

  return { interlocutors, setInterlocutors, fetchInterlocutors }
}

export default useInterlocutors
